import { StandardEvents } from '@shopify/events';

const cartDestination = Theme.routes.cart_url || '/cart';
const cartPathname = new URL(cartDestination, window.location.origin).pathname.replace(/\/$/, '') || '/';
const pendingForms = new WeakMap();
const pendingUpsellProducts = new Map();

function isCartPage() {
  const currentPathname = window.location.pathname.replace(/\/$/, '') || '/';
  return currentPathname === cartPathname;
}

function standardProductFormFromSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return null;

  const submitter = event.submitter;
  if (!(submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement)) return null;

  const isStandardAdd =
    submitter.name === 'add' ||
    submitter.matches('[ref="addToCartButton"]') ||
    submitter.closest('add-to-cart-component');

  return isStandardAdd ? form : null;
}

function clearPendingForm(form) {
  const pending = pendingForms.get(form);
  if (!pending) return;

  window.clearTimeout(pending.timeout);
  pending.submitter?.removeAttribute('aria-busy');
  form.removeAttribute('data-clearvero-cart-submitting');
  pendingForms.delete(form);
}

function preventDuplicateAdd(event) {
  const form = standardProductFormFromSubmit(event);
  if (!form) return;

  if (pendingForms.has(form)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  const submitter = event.submitter;
  form.setAttribute('data-clearvero-cart-submitting', 'true');
  submitter?.setAttribute('aria-busy', 'true');

  const timeout = window.setTimeout(() => clearPendingForm(form), 10000);
  pendingForms.set(form, { submitter, timeout });
}

function upsellProductKey(button) {
  const component = button.closest('product-form-component');
  return component?.dataset.productId || null;
}

function preventDuplicateUpsellClick(event) {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest('[data-clearvero-upsell-card] button[type="submit"]');
  if (!(button instanceof HTMLButtonElement)) return;

  const key = upsellProductKey(button);
  if (!key) return;

  if (pendingUpsellProducts.has(key)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  button.setAttribute('aria-busy', 'true');
  const timeout = window.setTimeout(() => {
    pendingUpsellProducts.delete(key);
    button.removeAttribute('aria-busy');
  }, 3000);

  pendingUpsellProducts.set(key, timeout);
}

function productFormFromCartEvent(event) {
  if (!(event.target instanceof Element)) return null;

  const productForm = event.target.matches('product-form-component')
    ? event.target
    : event.target.closest('product-form-component');

  return productForm?.querySelector('form') || null;
}

function redirectSuccessfulAddToCart(event) {
  if (event.action !== 'add') return;

  const form = productFormFromCartEvent(event);
  if (!event.promise || typeof event.promise.then !== 'function') {
    if (form) clearPendingForm(form);
    return;
  }

  event.promise
    .then(({ detail }) => {
      if (detail?.didError) {
        if (form) clearPendingForm(form);
        return;
      }

      if (isCartPage()) {
        if (form) clearPendingForm(form);
        return;
      }

      window.location.assign(cartDestination);
    })
    .catch(() => {
      if (form) clearPendingForm(form);
      // Native Horizon components surface add and network errors.
    });
}

document.addEventListener('click', preventDuplicateUpsellClick, true);
document.addEventListener('submit', preventDuplicateAdd, true);
document.addEventListener(StandardEvents.cartLinesUpdate, redirectSuccessfulAddToCart);
